var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('JuegosNavar'),_c('JuegoBanner'),_c('CategoriasJuegos'),_c('JuegosFqa'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }